import { Button, Dropdown, Icon, List, Menu, Row, Col, Tag, Popconfirm, Spin } from "antd";
import { Typography } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import ExpandableCard from "../general/ExpandableCard/ExpandableCard";
import history from "../../utils/history";
import "./UsersList.css";
import { showSuccessToast } from "../general/ToastHelper";
import { UserService } from "../../services/user/UserService";
import { handleError } from "../../utils/ErrorHandlers";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { Constants } from "../../data/constants";
import { invitationService } from "../../services/invitation/InvitationService";
const { Text } = Typography;

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      isLoading: false,
      showForm: false,
      user: null,
      showInnerCard: false,
      accountType: this.props.accountType,
      accountId:this.props.accountId
    };
    this.userService = new UserService();

    this.constants = new Constants()
  }
  editUSer(userId) {
    history.push(`/home/users/edit/${userId}`);
  }
  viewUser(userId) {
    history.push(`/home/users/view/${userId}`);
  }
  async deleteUser(userId, userType) {
    try {
      let data = await this.userService.deleteUser(
        this.props.context.session_id,
        userId,
        userType
      );
      showSuccessToast(i18next.t("Delete User ") + i18next.t(data.statusMsg));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  async resetPassword(userId) {
    this.setState({ isLoading: true });
    try {
      let { id } = this.props.match.params;
      let requestData = {
        userId: userId,
        accountId:
        this.state.accountType === this.constants.userTypeList.super ||  this.state.accountType === this.constants.userTypeList.customerCare
        ? id : this.state.accountId,
      };
      let data = await this.userService.resetPassword(
        this.props.context.session_id,
        requestData
      );
      showSuccessToast(i18next.t("Password has been reset successfully"));
      this.setState({ isLoading: false });
      this.handleRefresh();
    } catch (e) {
      this.setState({ isLoading: false });
      handleError(e);
    }
  }

 async resendInvitation(userId){
    console.log("================= "+userId)
     try {
      let data = await invitationService.resendInvitation(this.props.context.session_id,userId)
      showSuccessToast(i18next.t("Resend Invitation ") + i18next.t(data.statusMsg));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }
  async cancelInvitaion(userId){
    console.log("================= "+userId)
    this.setState({ isLoading: true });
    try {
       let requestData = {
        userId: userId,
        invitationId: null
      };
       let data = await invitationService.cancelInvitation(
        this.props.context.session_id,
        requestData
      );
      showSuccessToast(i18next.t("Invitation has been canceled successfully"));
      this.setState({ isLoading: false });
            this.handleRefresh();


    }catch(e) {
    this.setState({ isLoading: false });
      handleError(e);
    }

  }
  handleRefresh() {
    this.setState({ isFetching: true });
    this.props.onRefresh();
  }
  renderUserDropdown(user) {
    console.log("===================== "+user.userType);
    const menu =
      ![this.constants.userTypeList.super , this.constants.userTypeList.customerCare].includes(this.state.accountType) ? (
        <Menu>
          <Menu.Item onClick={() => this.editUSer(user.userId)}>
            <span>{i18next.t("Edit")}</span>
            <Icon className={"edit-account-style"} type="edit" />
          </Menu.Item>
          <Menu.Item>
            <Popconfirm
              title={i18next.t("Are you sure delete this user?")}
              onConfirm={() => this.deleteUser(user.userId, user.userType)}
              okText={i18next.t("Yes")}
              cancelText={i18next.t("No")}
            >
              <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                {i18next.t("Delete User")}
                <Icon className={"delete-account-style"} type="delete" />
              </a>
            </Popconfirm>
          </Menu.Item>
          <Menu.Item onClick={() => this.viewUser(user.userId)}>
            <span>{i18next.t("View Details")}</span>
            <Icon className={"view-details-style"} type="eye" />
          </Menu.Item>
          <Menu.Item onClick={() => this.resetPassword(user.userId)}>
            <Spin spinning={this.state.isLoading}>
              <span>{i18next.t("Reset Password")}</span>
              <Icon className={"delete-account-style"} type="redo" />
            </Spin>
          </Menu.Item>
        </Menu>
      ) : (
        <Menu>
          <Menu.Item onClick={() => this.resetPassword(user.userId)}>
            <Spin spinning={this.state.isLoading}>
              <span>{i18next.t("Reset Password")}</span>
              <Icon className={"delete-account-style"} type="redo" />
            </Spin>
          </Menu.Item>
        </Menu>
      );

      const geustMenu = (   <Menu>
          <Menu.Item onClick={() => this.resendInvitation(user.userId)}>
            <Spin spinning={this.state.isLoading}>
              <span>{i18next.t("Resend Invitation")}</span>
              <Icon className={"delete-account-style"} type="redo" />
            </Spin>
          </Menu.Item>
          {/* <Menu.Item onClick={() => this.cancelInvitaion(user.userId)}>
            <Spin spinning={this.state.isLoading}>
              <span>{i18next.t("Cancel Invitation")}</span>
              <Icon className={"delete-account-style"} type="close" />
            </Spin>
          </Menu.Item> */}
           <Menu.Item>
            <Popconfirm
              title={i18next.t("Are you sure cancel this invitation?")}
              onConfirm={() => this.cancelInvitaion(user.userId)}
              okText={i18next.t("Yes")}
              cancelText={i18next.t("No")}
            >
              <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                {i18next.t("Cancel Invitation")}
                <Icon className={"delete-account-style"} type="close" />
              </a>
            </Popconfirm>
          </Menu.Item>
        </Menu>);
    return (
      <Dropdown overlay={user.userType == 'GUEST' ? geustMenu : menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={user} type="more" />
        </Button>
      </Dropdown>
    );
  }

  renderDetails(item) {
    return (
      <Translation>
        {(t) => (
          <>
            <Row>
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("User Name")}</Text>
                <Tag className="m-2">{item.userName}</Tag>
              </Col>
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("Email")}</Text>
                <Tag className="m-2">{item.userEmail}</Tag>
              </Col>
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("UserType")}</Text>
                <Tag className="m-2">
                  {item.userType === "ADMIN" ? t("Admin") : null}
                  {item.userType === "AGENT" ? t("Agent") : null}
                  {item.userType === "GUEST" ? t("Guest") : null}

                </Tag>
              </Col>
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("User Full Name")}</Text>
                <Tag className="m-2">{item.userFullname}</Tag>
              </Col>

              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("User Gender")}</Text>
                <Tag className="m-2">
                  {item.userGender === "M" ? t("Male") : null}
                  {item.userGender === "F" ? t("Female") : null}
                </Tag>
              </Col>
              {/* <Col xs={24} lg={8}>
    <Text className="small-text"> {t("User Birthdate")}</Text>
    <Tag className="m-2">{item.userBirthdate}</Tag>
  </Col> */}
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("User Number")}</Text>
                <Tag className="m-2">{item.userNumber}</Tag>
              </Col>
            </Row>
            <Row>
              <Col xs={24} lg={12}>
                <Text className="small-text"> {t("User Birthdate")}</Text>
                <Tag className="m-2">{item.userBirthdate}</Tag>
              </Col>
            </Row>
          </>
        )}
      </Translation>
    );
  }

  showInnerCard(showInnerCard) {
    this.setState({ showInnerCard: !showInnerCard });
  }

  render() {
    let { data } = this.props;
    return (
      <List
        dataSource={data}
        renderItem={(item) => {
          return (
            <ExpandableCard
              title={item.userName}
              renderDropDown={this.renderUserDropdown(item)}
              renderDetails={this.renderDetails(item)}
              showCaretIcon={false}
              status={item.agentStatus}
              type={item.userType}
              // type={item.agentStatus}
            />
          );
        }}
      />
    );
  }
}

export default withSharedStateConsumer(withRouter(UsersList));
